import { InsureIQPolicyTypes } from '@harvestiq/constants';
import { z, zCalendarDate } from '@harvestiq/zod';
import { claimSchema } from './claim';
import { ClaimStatuses } from './claim-statuses';

// request types
export const getClaimsRequestSchema = z.object({
  ids: z.array(z.string().uuid()).optional(),
  agentIds: z.array(z.string().uuid()).optional(),
  searchText: z.string().optional(),
  searchFields: z
    .array(z.enum(['firstName', 'lastName', 'businessName', 'email']))
    .optional(),
  endorsementType: z.nativeEnum(InsureIQPolicyTypes).optional(),
  endorsementEndDateStart: zCalendarDate().optional(),
  endorsementEndDateEnd: zCalendarDate().optional(),
  statuses: z.nativeEnum(ClaimStatuses).array().optional(),
  skip: z.coerce.number().int().nonnegative().optional(),
  limit: z.coerce.number().int().positive().optional(),
});
export type GetClaimsRequest = z.infer<typeof getClaimsRequestSchema>;

// response types
export const getClaimsResponseSchema = z.object({
  claims: z.array(claimSchema),
  totalCount: z.number(),
});
export type GetClaimsResponse = z.infer<typeof getClaimsResponseSchema>;
